import React from "react";

export default function Sky() {
  return (
    <div className="sky">
      <div className="cloud"></div>
    </div>
  );
}
